import * as z from "zod";

export const triggerHubspotMirrorSyncInputSchema = z.object({
  /**
   * Both modes resume from the current bookmark. Without a bookmark, `hourly`
   * uses a 24-hour lookback and `nightly` uses the onboarding-record floor.
   */
  mode: z.enum(["hourly", "nightly"]).default("nightly"),
});
export type TriggerHubspotMirrorSyncInput = z.infer<
  typeof triggerHubspotMirrorSyncInputSchema
>;

export const triggerHubspotMirrorSyncOutputSchema = z.object({
  success: z.boolean(),
  workflowId: z.string().nullable(),
  error: z.string().nullable(),
});
export type TriggerHubspotMirrorSyncOutput = z.infer<
  typeof triggerHubspotMirrorSyncOutputSchema
>;

export const triggerHubspotMirrorSync = {
  name: "triggerHubspotMirrorSync" as const,
  input: triggerHubspotMirrorSyncInputSchema,
  output: triggerHubspotMirrorSyncOutputSchema,
};
